import { ChangeEvent, FC, useContext } from 'react';
import { TransferContext } from './TransferContext';
import { useFormContext } from 'react-hook-form';
import { TransferFormFieldValues } from './SelectedConversationTransferModal';
import { Box, TextField, Typography } from '@mui/material';
import { CreateOutlined } from '@mui/icons-material';

const TransferModalNote: FC = () => {
  const { filteredAssociates } = useContext(TransferContext);

  const {
    setValue,
    clearErrors,
    formState: { errors: formErrors },
    getValues,
  } = useFormContext<TransferFormFieldValues>();

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setValue('note', value);
    clearErrors('note');
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <TextField
        disabled={filteredAssociates.length === 0}
        value={getValues('note')}
        variant="outlined"
        multiline
        minRows={4}
        placeholder="Note (required)"
        onChange={handleChange}
        slotProps={{
          htmlInput: {
            maxLength: 90,
          },
          input: {
            startAdornment: (
              <CreateOutlined
                sx={(theme) => ({
                  marginRight: theme.spacing(1),
                  alignSelf: 'baseline',
                })}
              />
            ),
          },
        }}
        sx={{ width: '100%' }}
        error={Boolean(formErrors?.note)}
        label={formErrors?.note?.message || ''}
      />
      <Typography
        variant="caption"
        color="textSecondary"
        sx={(theme) => ({
          position: 'absolute',
          right: theme.spacing(2),
          bottom: theme.spacing(2),
        })}
      >
        {getValues('note').length}/90 characters
      </Typography>
    </Box>
  );
};

export default TransferModalNote;
